export default "__VITE_ASSET__Bdh__ECl__"